module.exports = __webpack_public_path__ + "static/media/computer.6bd5e9f6.png";